<template>
  <div :class="{ 'p-6': $mq != 'mobile', 'p-4': $mq == 'mobile' }">
    <p
      class="uppercase text-lg font-medium text-brand text-center my-6"
      v-if="$mq == 'mobile'"
    >
      Enter the Property Address
    </p>
    <div v-if="sub_step == 1" :class="{ 'p-6 border': $mq != 'mobile' }">
      <p
        class="uppercase text-lg font-light text-center my-6"
        v-if="$mq != 'mobile'"
      >
        To get started enter the property address
      </p>

      <div class="my-8 mb-2" v-if="use_addressify">
        <p
          class="text-lg font-medium text-grey-dark text-center my-6"
          v-if="$mq == 'mobile'"
        >
          Property address
        </p>
        <auto-complete
          :debounce="250"
          url="/api/register/search-address"
          anchor="formatted_address"
          label="label_placeholders"
          param="address"
          name="autocomplete"
          placeholder="Property Address"
          :on-select="autocompleteProperty"
          :classes="{
            wrapper: 'p-0',
            input: 'form-control',
            list: '',
            item: '',
          }"
          :on-input="addressSearchInput"
          :on-before-ajax="searchingStart"
          :on-ajax-loaded="searchingStop"
          @manual-encode="address_details = !address_details"
        ></auto-complete>
      </div>

      <div class="bg-brand-lightest p-4 rounded" v-if="searching">
        <i class="fa fa-spinner fa-spin"></i> Searching
      </div>

      <div
        class="bg-red-lightest flex justify-between p-3 rounded items-center"
        v-if="add_not_found && searching == false"
      >
        <span class="text-red text-base font-medium">
          <i class="fa fa-exclamation-triangle"></i> Address not found
        </span>
        <button
          class="
            border
            p-2
            sm:py-3 sm:px-4
            text-black
            bg-white
            rounded
            font-semibold
            text-sm2
          "
          type="button"
          @click="address_details = !address_details"
        >
          <i class="fa fa-plus text-brand"></i> Add your Address
        </button>
      </div>

      <div
        class="bg-red-lightest flex justify-between p-3 rounded items-center"
        v-if="with_duplicate_address"
      >
        <p class="text-red text-base font-medium">
          This address already has a Vault, please contact your management.
        </p>
      </div>

      <form
        class="py-4 mt-4"
        v-if="address_details || !use_addressify"
        @submit.prevent="validateAndNext"
      >
        <div class="flex flex-wrap">
          <div class="w-full w-full sm:w-1/3 md:w-1/2 sm:pt-0 sm:pr-8">
            <label class="font-medium text-center sm:text-left">
              <span class="text-brand">*</span> Address
            </label>
            <input
              type="text"
              class="w-full border py-2 px-3 mt-2 rounded"
              v-model="form.vault.address"
              v-validate="'required'"
              name="address"
              tabindex="1"
              :class="{ 'border-red': errors.has('address') }"
            />
            <div v-show="errors.has('address')" class="text-red text-sm mt-2">
              {{ errors.first("address") }}
            </div>
          </div>

          <div class="w-full sm:w-1/3 md:w-1/2 pt-4 sm:pt-0">
            <label class="font-medium text-center sm:text-left">Suburb</label>
            <input
              type="text"
              class="w-full border py-2 px-3 mt-2 rounded"
              tabindex="2"
              v-model="form.vault.suburb"
            />
          </div>
        </div>
        <div class="flex flex-wrap m-0 sm:mt-4">
          <div class="w-full sm:w-1/3 md:w-1/3 pt-4 sm:pt-0 sm:pr-8">
            <label class="font-medium text-center sm:text-left"><span class="text-brand">*</span> Country</label>
            <multiselect
              v-model="form.vault.country"
              class="mt-2"
              name="country"
              placeholder="Please Select"
              track-by="code"
              label="name"
              :options="countries"
              :showLabels="false"
              :searchable="false"
              :tabindex="3"
              v-validate="'required'"
              :class="{ 'invalid': errors.has('country') }"
            ></multiselect>
            <div v-show="errors.has('country')" class="text-red text-sm mt-2">
              {{ errors.first("country") }}
            </div>
          </div>
          <div class="w-full sm:w-1/3 md:w-1/3 pt-4 sm:pt-0 sm:pr-8">
            <label class="font-medium text-center sm:text-left"><span class="text-brand">*</span> {{ isNZ ? 'Type' : 'State' }}</label>
            <multiselect
              v-model="form.vault.state"
              class="mt-2"
              name="state"
              placeholder="Please Select"
              track-by="code"
              label="name"
              :options="states"
              :showLabels="false"
              :searchable="false"
              :tabindex="4"
              v-validate="'required'"
              :class="{ 'invalid': errors.has('state') }"
            ></multiselect>
            <div v-show="errors.has('state')" class="text-red text-sm mt-2">
              {{ errors.first("state") }}
            </div>
          </div>
          <div class="w-full sm:w-1/3 md:w-1/3 pt-4 sm:pt-0">
            <label class="font-medium text-center sm:text-left">Postcode</label>
            <input
              type="text"
              class="w-full border py-2 px-3 mt-2 rounded"
              tabindex="5"
              v-model="form.vault.postcode"
            />
          </div>
        </div>

        <button type="submit" class="invisible"></button>
      </form>
    </div>

    <div v-if="sub_step == 2" :class="{ 'p-6 border': $mq != 'mobile' }">
      <form class="py-4 mt-4" @submit.prevent="validateAndNext">
        <div class="flex flex-wrap text-center sm:text-left">
          <div class="w-full sm:w-3/4">
            <label class="font-medium">
              <span class="text-brand">*</span> Property Address
            </label>
            <p class="mt-2" v-if="!edit_address">
              {{ form.vault.address }}
              <button
                type="button"
                class="border p-2 rounded"
                @click.prevent="edit_address = true"
              >
                Edit
              </button>
            </p>

            <div
              class="p-4 bg-grey-lightest sm:mt-2 sm:mr-2"
              v-if="edit_address"
            >
              <div class="flex flex-wrap">
                <div class="w-full sm:w-1/2 sm:pr-8 mt-4 sm:m-0">
                  <label class="font-medium text-grey-dark">Address</label>
                  <input
                    type="text"
                    class="w-full border py-2 px-3 mt-2 rounded"
                    v-model="form.vault.address"
                    v-validate="'required'"
                    name="address"
                    tabindex="1"
                    :class="{ 'border-red': errors.has('address') }"
                  />
                  <div
                    v-show="errors.has('address')"
                    class="text-red text-sm mt-2"
                  >
                    {{ errors.first("address") }}
                  </div>
                </div>

                <div class="w-full sm:w-1/2 mt-4 sm:m-0">
                  <label class="font-medium text-grey-dark">Suburb</label>
                  <input
                    type="text"
                    class="w-full border py-2 px-3 mt-2 rounded"
                    v-model="form.vault.suburb"
                    tabindex="2"
                  />
                </div>
              </div>
              <div class="flex flex-wrap sm:mt-4">
                <div class="w-full sm:w-1/3 md:w-1/3 pt-4 sm:pt-0 sm:pr-8">
                  <label class="font-medium text-center sm:text-left"><span class="text-brand">*</span> Country</label>
                  <multiselect
                    v-model="form.vault.country"
                    class="mt-2"
                    name="country"
                    placeholder="Please Select"
                    track-by="code"
                    label="name"
                    :options="countries"
                    :showLabels="false"
                    :searchable="false"
                    :tabindex="3"
                    v-validate="'required'"
                    :class="{ 'invalid': errors.has('country') }"
                  ></multiselect>
                  <div v-show="errors.has('country')" class="text-red text-sm mt-2">
                    {{ errors.first("country") }}
                  </div>
                </div>
                <div class="w-full sm:w-1/4 sm:pr-8 mt-4 sm:m-0">
                  <label class="font-medium text-grey-dark"><span class="text-brand">*</span> {{ isNZ ? 'Type' : 'State' }}</label>
                  <multiselect
                    v-model="form.vault.state"
                    class="mt-2"
                    name="state"
                    track-by="code"
                    label="name"
                    placeholder="Please Select"
                    :options="states"
                    :searchable="false"
                    :tabindex="3"
                    :showLabels="false"
                    v-validate="'required'"
                    :class="{ 'invalid': errors.has('state') }"
                  ></multiselect>
                  <div v-show="errors.has('state')" class="text-red text-sm mt-2">
                    {{ errors.first("state") }}
                  </div>
                </div>
                <div class="w-full sm:w-1/4 mt-4 sm:m-0">
                  <label class="font-medium text-grey-dark">Postcode</label>
                  <input
                    type="text"
                    class="w-full border py-2 px-3 mt-2 rounded"
                    v-model="form.vault.postcode"
                    tabindex="4"
                  />
                </div>
              </div>
              <button
                type="button"
                class="border border-brand text-brand p-1 mt-2 rounded text-sm"
                @click="edit_address = false"
              >
                Close Editing
              </button>
            </div>
          </div>
          <div class="w-full sm:w-1/4 mt-4 sm:mt-0">
            <label class="font-medium">
              <span class="text-brand">*</span> Plan Number
            </label>
            <input
              type="text"
              class="w-full border py-2 px-3 mt-2 rounded"
              v-model="form.vault.strata_plan_number"
              v-validate="'required'"
              name="plan_number"
              tabindex="5"
              :class="{ 'border-red': errors.has('plan_number') }"
            />
            <div
              v-show="errors.has('plan_number')"
              class="text-red text-sm mt-2"
            >
              {{ errors.first("plan_number") }}
            </div>
          </div>
        </div>
        <div class="flex flex-wrap sm:mt-4 text-center sm:text-left">
          <div class="w-full sm:w-1/2 sm:pr-8 mt-4 sm:mt-0">
            <label class="font-medium">
              <span class="text-brand">*</span> Vault Name
            </label>
            <input
              type="text"
              class="w-full border py-2 px-3 mt-2 rounded"
              v-model="form.vault.name"
              v-validate="'required'"
              name="vault_name"
              tabindex="6"
              :class="{ 'border-red': errors.has('vault_name') }"
            />
            <div
              v-show="errors.has('vault_name')"
              class="text-red text-sm mt-2"
            >
              {{ errors.first("vault_name") }}
            </div>
          </div>
          <div class="w-full sm:w-1/4 sm:pr-8 mt-4 sm:mt-0">
            <label class="font-medium">
              <span class="text-brand">*</span> Property Type
            </label>
            <input
              type="text"
              class="w-full border py-2 px-3 mt-2 rounded"
              v-model="form.vault.building_type"
              v-validate="'required'"
              name="property_type"
              tabindex="7"
              :class="{ 'border-red': errors.has('property_type') }"
            />
            <div
              v-show="errors.has('property_type')"
              class="text-red text-sm mt-2"
            >
              {{ errors.first("property_type") }}
            </div>
          </div>
          <div class="w-full sm:w-1/4 mt-4 sm:mt-0">
            <label class="font-medium">
              <span class="text-brand">*</span> Number of Lots
            </label>
            <input
              type="text"
              class="w-full border py-2 px-3 mt-2 rounded"
              v-model="form.vault.number_of_lots"
              v-validate="'required|numeric'"
              name="number_of_lots"
              tabindex="7"
              :class="{ 'border-red': errors.has('number_of_lots') }"
            />
            <div
              v-show="errors.has('number_of_lots')"
              class="text-red text-sm mt-2"
            >
              {{ errors.first("number_of_lots") }}
            </div>
          </div>
        </div>
        <button type="submit" class="invisible"></button>
      </form>
    </div>

    <div class="text-center mt-4" v-if="detailReview">
      <button
        class="
          border
          bg-grey-lighter
          p-4
          w-32
          text-black
          border-grey
          rounded
          font-medium
        "
        type="submit"
        @click="backToFinish()"
      >
        Back
      </button>
    </div>

    <div
      class="text-right mt-4"
      v-else-if="address_details || sub_step == 2 || !use_addressify"
    >
      <button
        class="border bg-brand p-4 w-32 text-white rounded font-medium"
        type="submit"
        @click="validateAndNext()"
      >
        Continue
      </button>
    </div>
  </div>
</template>

<script>
import AutoComplete from "../AutoComplete";

export default {
  components: {
    AutoComplete,
  },

  props: [
    "value",
    "step",
    "current-step",
    "current-sub-step",
    "detail-review",
    "steps",
  ],

  data() {
    return {
      form: _.cloneDeep(this.value),
      add_not_found: false,
      searching: false,
      address_details: false,
      sub_step: this.currentSubStep,
      next: "",
      countries: [
        { code: "AU", name: "Australia" },
        { code: "NZ", name: "New Zealand" },
      ],
      edit_address: false,

      not_mobile: false,

      found_vaults: {},
      with_duplicate_address: false,
    };
  },

  mounted() {
    let next = _.toNumber(this.step) + 1;
    this.next = next;
  },

  methods: {
    autocompleteProperty(address) {
      axios
        .post(`api/register/check-duplicate-vault-by-address`, {
          address: address.formatted_address,
          postcode: address.postcode,
          state: address.state,
          suburb: address.suburb,
        })
        .then(({ data }) => {
          if (data.success) {
            if (data.found_vaults > 0) {
              this.with_duplicate_address = true;
              this.found_vaults = data.found_vaults;
            } else {
              this.form.vault.address = address.formatted_address;
              this.form.vault.postcode = address.postcode;
              this.form.vault.state = address.state;
              this.form.vault.suburb = address.suburb;
              this.sub_step = 2;
            }
          }
        });
    },
    addressSearchInput(input) {
      this.form.vault.address = input;
    },
    searchingStart(obj) {
      this.searching = true;
      this.add_not_found = false;
      this.with_duplicate_address = false;
    },
    searchingStop(obj) {
      if (obj.length == 0) {
        this.add_not_found = true;
      }
      this.searching = false;
    },
    validateAndNext() {
      this.$validator.validateAll().then((result) => {
        console.log(this.form);
        // set other invoice_details field to property field
        this.form.billing.address = this.form.vault.address;
        this.form.billing.postcode = this.form.vault.postcode;
        this.form.billing.state = this.form.vault.state
          ? this.form.vault.state.name
          : "";
        this.form.billing.suburb = this.form.vault.suburb;

        if (result) {
          if (this.sub_step == 2) {
            this.$emit("go-to", {
              next_step: this.next,
            });
          } else {
            this.sub_step = 2;
          }
        }
      });
    },
    backToFinish() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$emit("go-to", {
            next_step: _.findLastKey(this.steps),
          });
        }
      });
    },
  },

  watch: {
    form: {
      deep: true,
      handler: function () {
        this.$emit("input", this.form);
      },
    },
  },

  computed: {
    states() {
      if (this.form.vault.country && this.form.vault.country.code == "NZ") {
        return [
          { code: "Body Corporate", name: "Body Corporate" },
          { code: "Residents Association", name: "Residents Association" },
          { code: "Incorporated Society", name: "Incorporated Society" },
          { code: "Cross Lease (XL)", name: "Cross Lease (XL)" }
        ];
      }

      return [
          { code: "ACT", name: "Australian Capital Territory" },
          { code: "NSW", name: "New South Wales" },
          { code: "NT", name: "Northern Territory" },
          { code: "QLD", name: "Queensland" },
          { code: "SA", name: "South Australia" },
          { code: "TAS", name: "Tasmania" },
          { code: "VIC", name: "Victoria" },
          { code: "WA", name: "Western Australia" },
      ];
    },
    isNZ() {
      if (this.form.vault.country && this.form.vault.country.code == "NZ") {
        this.form.vault.state = "";
        this.$emit('getSubscriptions', 'NZ');
        return true;
      }
      this.form.vault.state = "";
      this.$emit('getSubscriptions', 'AUD');
      return false;
    },
    use_addressify() {
      return window.enable_addressify;
    },
  },
};
</script>

<style>
.multiselect__tags {
  min-height: 0px;
  display: block;
  padding: 6px 40px 0 8px;
  border-radius: 5px;
  border: 1px solid #dadee7;
  background: #fff;
}
.invalid > .multiselect__tags {
  border: 1px solid #e3342f;
}
.multiselect__input {
  font-size: 16px;
}
</style>
